import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Typography, Button, useMediaQuery } from '@material-ui/core';

// CONSTANTS
import { ROUTE_MOBILE_APP } from '@/constants/routes';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import Link from '@/components/Link';

// STYLES
import { Container } from './styles';

const SMImg = getS3ImageUrl('/iPhone-15-Pro.png', '/cp-uploads');

const AppSection = ({ type, title, titleProps, subtitle, subtitleProps }) => {
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  const { partner } = useSelector(({ partner: partnerStore }) => ({
    partnerData: partnerStore.data,
  }));
  const textOverwrites = partner?.text_overwrites || {};

  const btnContent = (
    <div className="text-center">
      <Button
        to={ROUTE_MOBILE_APP}
        className="m-b-30"
        size={clsx(downXs ? 'medium' : 'large')}
        color="primary"
        component={Link}
        fullWidth={downXs}
      >
        {textOverwrites.app_section_button_text || t('buttons.downloadNow')}
      </Button>
    </div>
  );

  const titleContent = (
    <>
      {!!title && (
        <Typography
          {...titleProps}
          className={clsx('m-b-15 text-bold', !!titleProps.className && titleProps.className)}
          component="h2"
          variant={downXs ? 'h4' : 'h2'}
          align="center"
        >
          {title}
        </Typography>
      )}
      {!!subtitle && (
        <Typography
          {...subtitleProps}
          className={clsx('m-b-15', !!titleProps.className && subtitleProps.className)}
          variant="subtitle2"
          align="center"
        >
          {subtitle}
        </Typography>
      )}
    </>
  );

  return (
    <Container className={clsx('section app-section', type && `app-section--${type}`)}>
      <div className="page-content">
        {titleContent}
        {btnContent}
        <div className="app-section__img">
          <img src={SMImg} alt="shows-movies" />
        </div>
      </div>
    </Container>
  );
};

AppSection.defaultProps = {
  type: 'default',
  titleProps: {},
  subtitleProps: {},
};

AppSection.propTypes = {
  type: PropTypes.oneOf(['default', 'p-home']),
  title: PropTypes.string,
  titleProps: PropTypes.object,
  subtitle: PropTypes.string,
  subtitleProps: PropTypes.object,
};

export default React.memo(AppSection);
